<template>
    <el-dropdown
        :class="{'el-dropdown-active': visible}"
        trigger="click"
        :hide-on-click="false"
        @command="handleAction"
        :placement="placement"
        @visible-change="val=>visible=val"
    >
        <slot>
            <span :style="{color}" class="tag br6">
                <cl-svg-icon :width="iconW" :icon-class="currentIcon"></cl-svg-icon>
            </span>
        </slot>

        <el-dropdown-menu slot="dropdown">
            <div class="dropdown">
                <cl-tag-group
                    class="ml10 mr10"
                    :list="selectedList"
                    :disabled="false"
                    @delete="deleteFn"
                ></cl-tag-group>
                <el-input
                    style="width: 282px;"
                    class="mb10 mt6 ml10"
                    size="medium"
                    v-model="seachLabel"
                    :placeholder="$t('common.请输入')"
                    v-debounce="[seach,`keydown`,300,'input']"
                >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-dropdown-item
                    :command="item.id"
                    :item="item"
                    v-for="item in list"
                    :key="item.value"
                >
                    <cl-tag :item="item"></cl-tag>
                </el-dropdown-item>
            </div>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
/**
 * ComponentName: 标签筛选
 * Created Date:2022/5/7
 * Author: Nancy
 * Modify: zhanghui·chen 2022/5/16
 * 组件说明：
 * 标签筛选组件，标签列表传入，显示。
 * eg:
 *     <cl-label-popup v-model="select" :list="list" :load-data=""></cl-label-popup>
 */
export default {
    name: 'cl-label-popup',

    model: {
        prop: 'value',
        event: 'change'
    },

    props: {
        placement: {
            type: String,
            default: 'bottom-end'
        },
        value: {
            type: Array,
            default: () => []
        },
        list: {
            type: Array,
            default: () => []
        },
        loadData: {
            type: Function,
            default: () => new Function()
        },
        color: {
            type: String,
            default: '#81818A'
        },
        // 标签icon图标
        tagIcon: {
            type: String,
            default: ''
        },
        // icon图标宽度
        iconW: {
            type: [String, Number],
            default: 34
        }
    },
    data () {
        return {
            seachLabel: '', // 搜索的标签名
            selectedList: this.value || [], // 选择的标签列表
            visible: false, // 下拉框出现/隐藏
        }
    },
    computed: {
        // 当前标签图标
        currentIcon () {
            let icon = this.tagIcon;
            if (!icon) {
                icon = this.visible || this.selectedList.length ? 'tu_schedule_tag_active' : 'tu_schedule_tag'
            }
            return icon;
        }
    },
    watch: {
        value (val) {
            this.selectedList = val;
        }
    },
    created () {
        console.log(this.list)
    },
    methods: {
        // 删除选中
        deleteFn (item) {
            let i = this.selectedList.findIndex(el => el.name === item.name);
            this.selectedList.splice(i, 1);
            this.$emit('change', this.selectedList);
        },
        // 点击某一项
        handleAction (id, Vnode) {
            // console.log('id, Vnode::: ', id, Vnode)
            let item = Vnode.$attrs.item;
            let i = this.selectedList.findIndex(el => el.name === item.name);
            if (i === -1) this.selectedList.push(item);
            this.$emit('change', this.selectedList);
        },
        // 搜索标签
        seach () {
            this.loadData(this.seachLabel)
        },
        // 清空搜索标签
        resetSearch() {
            this.seachLabel = ''
        },
    }
}
</script>
<style lang="scss" scoped>
.dropdown {
    max-height: 400px;
    overflow: hidden auto;
}

.tag {
    display: inline-block;
    width: 34px;
    height: 34px;
    background-color: #fff;
    overflow: hidden;
}

.el-dropdown-menu {
    padding: 20px 10px;
    box-sizing: border-box;
    width: 330px;

    .el-dropdown-menu__item {
        line-height: 1;
        padding: 8px 10px;
        border-radius: 6px;

        &:hover {
            background: #f2f2f3;
            color: $base-font-major;
        }
    }
}
</style>